var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFacebook = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33613 2.31261C4.46243 2.14442 4.75712 2.01828 5.136 2.01828C5.51489 2.01828 5.93587 2.06032 6.35685 2.18647L6.69364 0.336379C5.97797 0.0840945 5.2623 0 4.50453 0C3.74676 0 3.15738 0.126143 2.6943 0.378427C2.23121 0.630711 1.89443 0.96709 1.72603 1.38756C1.55764 1.76599 1.47344 2.43875 1.47344 3.23765V3.95246H0V6.05483H1.47344V12.6983C2.10492 12.8245 2.73639 12.9086 3.36787 12.9086C3.62046 12.9086 3.87305 12.9085 4.12564 12.8665V6.05483H6.06216V3.95246H4.08354V3.2797C4.08354 2.81718 4.16774 2.4808 4.33613 2.31261Z",
    fill: "#00A8E1"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facebook.480813f4.svg";
export { ForwardRef as ReactComponent };